export const audioNextIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
  <path d="M13 0L13 12L11 12L11 -1.74846e-07L13 0ZM1.04907e-06 -1.1365e-06L9 6L0 12L1.04907e-06 -1.1365e-06Z" fill="var(--zbp-svg-primary-color, black)""/>
</svg>
`;
